




import { QR } from "qr-svg";
import { defineComponent, ref, watch } from "@vue/composition-api";

export default defineComponent({
  name: "BarCode",
  props: {
    value: { type: String, required: true }
  },
  setup(props) {
    const url = ref("");

    watch(
      () => props.value,
      (value, _, onInvalidate) => {
        const objectURL = URL.createObjectURL(
          new Blob([QR(value)], { type: "text/html" })
        );

        url.value = objectURL;

        onInvalidate(() => URL.revokeObjectURL(objectURL));
      },
      { immediate: true }
    );

    return { url };
  }
});
